module.exports = __webpack_public_path__ + "img/mendian.29fd3053.jpeg";